import _pipe from "lodash/fp/pipe";
import _isNil from "lodash/isNil";
import { useMotionValue } from 'framer-motion';
import { useCallback } from 'react';
export function useScrollShadow() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var topShadowRunwayHeight = options.topShadowRunwayHeight;
  var opacity = useMotionValue(0);
  var onScroll = useCallback(function (evt) {
    var _evt$currentTarget = evt === null || evt === void 0 ? void 0 : evt.currentTarget,
        scrollHeight = _evt$currentTarget.scrollHeight,
        scrollTop = _evt$currentTarget.scrollTop;

    var _getAlphaValue = _pipe(function (x) {
      return Number.prototype.toPrecision.call(x, 2);
    }, function (x) {
      return Math.max(0, x);
    }, function (x) {
      return Math.min(1, x);
    });

    var scrollRate = 4;
    var topValue = _isNil(topShadowRunwayHeight) ? scrollTop / (scrollHeight / scrollRate) : scrollTop / topShadowRunwayHeight;

    var top = _getAlphaValue(topValue);

    opacity.set(top);
  }, [opacity, topShadowRunwayHeight]);
  return {
    opacity: opacity,
    onScroll: onScroll
  };
}